import { useEffect } from "react";
import {
  medRecordList,
  downloadRecordFile,
} from "../../apiHandler/actions/profile";
import fileIcon from "../../assets/attached-file.png";
import { displayDateFormatter, DataGridCustomPagination } from "../helpers";
import { Skeleton } from "@material-ui/lab";
import { DataGrid } from "@mui/x-data-grid";

const Component = (props) => {
  const { medicalRecords, setMedicalRecords, uuid } = props;

  useEffect(() => {
    if (!medicalRecords) fetchMedication();
    // eslint-disable-next-line
  }, []);

  const fetchMedication = async () => {
    const response = await medRecordList(uuid);
    setMedicalRecords(
      response.map((r) => {
        return {
          id: r.id,
          createDate:
            (r.createDate && displayDateFormatter(r.createDate)) ||
            "Invalid Date",
          dateOfService:
            (r.dateOfService && displayDateFormatter(r.dateOfService)) ||
            "Invalid Date",
          doctorName: r.doctorName,
          doctorSpecialty: r.doctorSpecialty,
          facilityName: r.facilityName,
          comments: r.comments,
          fileType: r.fileType,
        };
      })
    );
  };

  const columns = [
    {
      field: "id",
      headerName: " ",
      renderCell: (e) => {
        return (
          <img
            onClick={() => downloadRecordFile(e.id, e.row.fileType, props.uuid)}
            src={fileIcon}
            width={23}
            height={26}
            alt="download"
          />
        );
      },
      filterable: false,
      sortable: false,
      align: "center",
    },
    {
      field: "createDate",
      headerName: "DATE OF UPLOAD",
      flex: 1,
    },
    { field: "dateOfService", headerName: "DATE OF SERVICE", flex: 1 },
    { field: "doctorName", headerName: "PROVIDER", flex: 1 },
    { field: "doctorSpecialty", headerName: "SPECIALITY", flex: 1 },
    { field: "facilityName", headerName: "HOSPITAL/PRACTIVE", flex: 1 },
    { field: "comments", headerName: "COMMENTS", flex: 1 },
  ];

  return (
    <div className="profile-table">
      {medicalRecords === null ? (
        <div className="profile-skeleton-cont">
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        </div>
      ) : (
        <DataGrid
          rows={medicalRecords}
          columns={columns}
          autoHeight="true"
          disableRowSelectionOnClick
          pagination
          pageSize={10}
          slots={{
            pagination: DataGridCustomPagination,
          }}
        />
      )}
    </div>
  );
};

export default Component;
